import React from "react";

import styles from "./InfoBox.module.css";
import SkeletonLoader from "../ResponseLoader/Skeleton loading/SkeletonLoader";

const InfoBox = ({
  header,
  subtitle,
  badge, // NEW: pill on the top right (e.g. "723 total open")
  subtitleProps,
  badgeProps, // NEW
  children,
  headerProps,
  loading = false,
  childrenProps,
  ...rest
}) => {
  const hasExtras = Boolean(subtitle || badge);

  const headerElement = (
    <h1
      {...headerProps}
      className={[
        styles.header,
        hasExtras && styles.headerInRow,
        headerProps?.className,
      ].filter(Boolean).join(" ")}
    >
      {loading ? (
        <SkeletonLoader style={{ width: "100%", height: "25px" }} />
      ) : (
        header
      )}
    </h1>
  );

  return (
    <div
      {...rest}
      className={[styles.infoBoxContainer, rest?.className].join(" ")}
    >
      {hasExtras ? (
        // Header row for a badge, with spacing controlled by the row container.
        <div className={styles.headerRow}>
          <div className={styles.headerText}>
            {headerElement}
            {subtitle && (
              <p
                {...subtitleProps}
                className={[styles.subtitle, subtitleProps?.className].join(" ")}
              >
                {subtitle}
              </p>
            )}
          </div>
          {badge && !loading && (
            <span
              {...badgeProps}
              className={[styles.badge, badgeProps?.className].join(" ")}
            >
              {badge}
            </span>
          )}
        </div>
      ) : (
        // Existing behavior: unchanged
        headerElement
      )}

      <div
        {...childrenProps}
        className={[styles.children, childrenProps?.className].join(" ")}
      >
        {children}
      </div>
    </div>
  );
};

export default InfoBox;
